module.exports = __webpack_public_path__ + "img/益视说明书_02.ecf100bf.png";